import React from 'react';
import { ChevronRightIcon, CalendarIcon, FileTextIcon, DollarSignIcon } from 'lucide-react';
import { Batch } from '../../lib/thetape-data';
interface BatchListProps {
  batches: Batch[];
  onSelectBatch: (batch: Batch) => void;
}
export function BatchList({
  batches,
  onSelectBatch
}: BatchListProps) {
  const formatCurrency = (val: number) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(val);
  return <div className="space-y-4" data-id="element-306">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-307">
        <div className="bg-slate-900 border border-slate-800 p-4" data-id="element-308">
          <div className="flex items-center gap-2 text-slate-500 mb-2" data-id="element-309">
            <DollarSignIcon size={16} data-id="element-310" />
            <span className="text-xs font-mono uppercase" data-id="element-311">
              Total Funded (YTD)
            </span>
          </div>
          <div className="text-2xl font-mono text-white font-semibold" data-id="element-312">
            $847.2M
          </div>
        </div>
        <div className="bg-slate-900 border border-slate-800 p-4" data-id="element-313">
          <div className="flex items-center gap-2 text-slate-500 mb-2" data-id="element-314">
            <FileTextIcon size={16} data-id="element-315" />
            <span className="text-xs font-mono uppercase" data-id="element-316">Total Invoices</span>
          </div>
          <div className="text-2xl font-mono text-white font-semibold" data-id="element-317">
            1,248
          </div>
        </div>
        <div className="bg-slate-900 border border-slate-800 p-4" data-id="element-318">
          <div className="flex items-center gap-2 text-slate-500 mb-2" data-id="element-319">
            <CalendarIcon size={16} data-id="element-320" />
            <span className="text-xs font-mono uppercase" data-id="element-321">Avg Tenor</span>
          </div>
          <div className="text-2xl font-mono text-white font-semibold" data-id="element-322">
            42 Days
          </div>
        </div>
      </div>

      <div className="w-full overflow-hidden border border-slate-800 bg-slate-900" data-id="element-323">
        <table className="w-full text-left text-sm" data-id="element-324">
          <thead data-id="element-325">
            <tr className="border-b border-slate-800 bg-slate-950/50 text-xs font-mono text-slate-400 uppercase tracking-wider" data-id="element-326">
              <th className="px-6 py-4 font-medium" data-id="element-327">Batch ID</th>
              <th className="px-6 py-4 font-medium" data-id="element-328">Close Date</th>
              <th className="px-6 py-4 font-medium text-right" data-id="element-329">
                Invoice Count
              </th>
              <th className="px-6 py-4 font-medium text-right" data-id="element-330">Total Amount</th>
              <th className="px-6 py-4 font-medium text-center" data-id="element-331">Avg Tenor</th>
              <th className="px-6 py-4 font-medium text-center" data-id="element-332">
                Verification
              </th>
              <th className="px-6 py-4 font-medium" data-id="element-333"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800" data-id="element-334">
            {batches.map(batch => <tr key={batch.id} onClick={() => onSelectBatch(batch)} className="group cursor-pointer hover:bg-slate-800/50 transition-colors" data-id="element-335">
                <td className="px-6 py-4 font-mono text-slate-300 group-hover:text-white font-medium" data-id="element-336">
                  {batch.id}
                </td>
                <td className="px-6 py-4 text-slate-400 font-mono text-xs" data-id="element-337">
                  {batch.closeDate}
                </td>
                <td className="px-6 py-4 font-mono text-right text-slate-300" data-id="element-338">
                  {batch.invoiceCount}
                </td>
                <td className="px-6 py-4 font-mono text-right text-slate-300 font-medium" data-id="element-339">
                  {formatCurrency(batch.totalAmount)}
                </td>
                <td className="px-6 py-4 font-mono text-center text-slate-400" data-id="element-340">
                  {batch.avgTenor}d
                </td>
                <td className="px-6 py-4 text-center" data-id="element-341">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-950/30 text-emerald-400 border border-emerald-900/50" data-id="element-342">
                    {batch.verificationRate}%
                  </span>
                </td>
                <td className="px-6 py-4 text-right text-slate-600 group-hover:text-slate-400" data-id="element-343">
                  <ChevronRightIcon size={18} data-id="element-344" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}